<section class="tooltip-container" fxFlex fxLayout="column">
  <mat-icon #arrow class="arrow" svgIcon="atoms-arrow"></mat-icon>
  <ng-template #container></ng-template>
</section>
